@for (model of formModel; track trackByFn($index, model)) {
  <ds-dynamic-form-control-container
    [formId]="formId"
    [formModel]="formModel"
    [group]="formGroup"
    [hasErrorMessaging]="model.hasErrorMessages"
    [hidden]="model.hidden"
    [class.d-none]="model.hidden"
    [layout]="formLayout"
    [model]="model"
    [templates]="templates"
    [asBootstrapFormGroup]="true"
    (dfBlur)="onCustomEvent($event, blur)"
    (dfChange)="onCustomEvent($event, change)"
    (dfFocus)="onCustomEvent($event, focus)"
    (ngbEvent)="onCustomEvent($event, ngbEvent)"></ds-dynamic-form-control-container>
}
